// Modules
import store from 'app-store';

// Action types
import { UPDATE_TRIAGE_ITEMS, UPDATE_TRIAGE_ITEM, SET_TRIAGE_USERS, SET_OPTION_MENU_OPEN } from './action-types';


// Eager update
export function eagerUpdate(item, type) {
  store.dispatch({ type: UPDATE_TRIAGE_ITEM, item, itemType: type });
}

// Action creators
export function update(items) {
  store.dispatch({ type: UPDATE_TRIAGE_ITEMS, items });
}

export function openForm(triageItem, optionMenuOpen) {
  store.dispatch({ type: SET_OPTION_MENU_OPEN, itemIdentifier: `${triageItem.id}-${triageItem.type}`, optionMenuOpen });
}

export function setUsers(users) {
  store.dispatch({ type: SET_TRIAGE_USERS, users });
}



// WEBPACK FOOTER //
// ./app/modules/triage/store/actions.js